import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useCallback, useEffect, useRef, useState } from 'react';
import { styled } from 'styled-components';
import { Box } from "../../box/src";
import { CATEGORIES, FontAwesomeIcon } from "../../font-awesome-icon/src";
import { MenuItem } from './components/MenuItem';
const DIRECTION = {
    left: 'left',
    right: 'right',
};
const SCROLL_STEP_WIDTH = 200;
export const HorizontalScrollMenu = ({ ariaLabel, menuItems, menuStyle, }) => {
    const scrollContainerRef = useRef(null);
    const [showLeftArrow, setShowLeftArrow] = useState(false);
    const [showRightArrow, setShowRightArrow] = useState(false);
    const checkArrowsPositions = useCallback(() => {
        if (!scrollContainerRef.current) {
            return;
        }
        const { clientWidth, scrollLeft, scrollWidth } = scrollContainerRef.current;
        if (clientWidth > 0 && scrollWidth > 0) {
            setShowLeftArrow(scrollLeft > 0);
            setShowRightArrow(scrollLeft + clientWidth + 2 < scrollWidth);
        }
    }, []);
    useEffect(() => {
        const scrollContainer = scrollContainerRef.current;
        if (!scrollContainer) {
            return undefined;
        }
        scrollContainer.addEventListener('scroll', checkArrowsPositions);
        window.addEventListener('resize', checkArrowsPositions);
        checkArrowsPositions();
        requestAnimationFrame(checkArrowsPositions);
        return () => {
            scrollContainer.removeEventListener('scroll', checkArrowsPositions);
            window.removeEventListener('resize', checkArrowsPositions);
        };
    }, [checkArrowsPositions, menuItems]);
    const handleArrowsClick = (direction) => {
        if (!scrollContainerRef.current) {
            return;
        }
        const leftPositionInContainer = scrollContainerRef.current.scrollLeft;
        const scrollValueByDirection = direction === DIRECTION.left ? -SCROLL_STEP_WIDTH : SCROLL_STEP_WIDTH;
        const scrollingToValue = leftPositionInContainer + scrollValueByDirection;
        scrollContainerRef.current.scrollTo({
            left: scrollingToValue,
            behavior: 'smooth',
        });
    };
    return (_jsxs(Nav, { "aria-label": ariaLabel, as: "nav", dataTestId: "horizontal-scroll-menu", children: [_jsx(ScrollContainer, { as: "ul", onScroll: checkArrowsPositions, ref: scrollContainerRef, role: "menubar", children: menuItems.map((menuItem) => (_jsx(MenuItem, { menuItem: menuItem, menuStyle: menuStyle, scrollContainerRef: scrollContainerRef }, menuItem.key))) }), showLeftArrow && (_jsx(NavigationButton, { "aria-hidden": "true", "data-testid": "left-arrow", left: true, onClick: () => handleArrowsClick(DIRECTION.left), children: _jsx(FontAwesomeIcon, { height: "12px", iconName: "angle-left", iconType: CATEGORIES.SOLID }) })), showRightArrow && (_jsx(NavigationButton, { "aria-hidden": "true", "data-testid": "right-arrow", onClick: () => handleArrowsClick(DIRECTION.right), right: true, children: _jsx(FontAwesomeIcon, { height: "12px", iconName: "angle-right", iconType: CATEGORIES.SOLID }) }))] }));
};
const Nav = styled(Box) `
  position: relative;
  width: 100%;
  align-items: center;
`;
const ScrollContainer = styled(Box) `
  position: relative;
  display: flex;
  scroll-behavior: smooth;
  scrollbar-width: none;
  -ms-overflow-style: none;
  flex: 1;
  overflow-x: auto;

  &::-webkit-scrollbar {
    display: none;
  }
`;
const NavigationButton = styled(Box) `
  position: absolute;
  ${({ left }) => left && 'left: 0;'}
  ${({ right }) => right && 'right: 0;'}
  background: ${({ theme }) => theme.colors.white};
  border: none;
  box-shadow: 0px 1px 6px 0px rgba(0, 0, 0, 0.1);
  border-radius: 5px;
  width: 28px;
  height: 28px;
  padding: 6px;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  color: ${({ theme }) => theme.colors.primary};
  transition: all 0.2s ease;
`;
//# sourceMappingURL=HorizontalScrollMenu.js.map